export default __webpack_public_path__ + "static/media/sidebar-uprs-test.f60e320f.png";